<template>
    <modal @close="modals.teamSwitcher = false">
        <h3>Switch Team</h3>
        <table id="team-switch-table">
            <div class="team-switch-team" v-for="c in teams" @click="switchTeam(c.team_id)">
                <img v-if="c.logo_url" :src="c.logo_url">
                <div class="team">{{ c.team_name }}</div>
                <div class="role">{{ fullRoleName(c.role) }}</div>
            </div>
        </table>
        <div class="form-actions">
            <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.teamSwitcher = false">CANCEL</span>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "TeamSwitcherModal",
    components: {Modal},
    props: {
    },
    data() {
        return {

        }
    },
    methods: {
        async switchTeam(id) {
            await this.$store.commit('switchTeamId', id);
            this.$router.go();
            this.modals.teamSwitcher = false;
        },
        fullRoleName(name) {
            if (name=='manager') return 'Team Manager';
            else if (name=='associate') return 'Team Associate';
            else if (name=='bb_admin') return 'BB HUB Account Manager';
            else if (name=='bb_spectator') return 'BB HUB Spectator';
            else return name;
        }
    },
    computed: {
        teams() {
            return this.$store.state.currentUserTeams;
        },
        modals() {
            return this.$store.state.modals;
        }
    }
}
</script>